import { UserRound, Building2 } from "lucide-react";

/**
 * Personal / Official shipment type selector (radio group).
 * Personal = employee's private parcel (no invoice/GST liability on employer).
 * Official = business shipment (billed to company · GST-eligible).
 */
export default function ShipmentTypeRadio({ value = "Personal", onChange, prefix = "st" }) {
  const options = [
    { v: "Personal", label: "Personal", desc: "Employee's private parcel", Icon: UserRound },
    { v: "Official", label: "Official", desc: "Business shipment · GST eligible", Icon: Building2 },
  ];
  return (
    <div className="space-y-2" data-testid={`${prefix}-shipment-type`}>
      <div className="overline">Shipment type</div>
      <div className="grid grid-cols-2 gap-3">
        {options.map(({ v, label, desc, Icon }) => {
          const active = value === v;
          return (
            <label
              key={v}
              data-testid={`${prefix}-shipment-type-${v.toLowerCase()}`}
              className={`flex items-start gap-3 border rounded-md p-3 cursor-pointer transition-colors ${
                active ? "border-primary bg-red-50 shadow-brut-orange" : "border-border hover:border-primary/40"
              }`}
            >
              <input
                type="radio"
                name={`${prefix}-shipment-type-radio`}
                checked={active}
                onChange={() => onChange(v)}
                className="mt-1 h-4 w-4 accent-[#BE1E1E] cursor-pointer"
              />
              <div className="flex-1">
                <div className="flex items-center gap-2 font-semibold text-sm">
                  <Icon size={14} className={active ? "text-primary" : "text-muted-foreground"} />
                  {label}
                </div>
                <div className="text-xs text-muted-foreground mt-0.5">{desc}</div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
